import { computed } from 'vue';
import type { Ref } from 'vue';

import { stuut } from '@/api';
import { useFeatureFlags } from '@/store/featureFlags';

interface UseFeatureFlagResult {
  ready: Ref<boolean>;
  updateFlag: (value: any) => Promise<void>;
  value: Ref<any>;
}

export const useFeatureFlag = (flag: string): UseFeatureFlagResult => {
  const featureFlagStore = useFeatureFlags();

  // Derive reactively from the shared store rather than copying into per-call
  // refs, so every consumer of the same flag flips together once the store
  // resolves (the store dedupes/caches the fetch).
  const ready = computed(() => featureFlagStore.loaded);
  const value = computed(() => featureFlagStore.flags[flag] ?? false);

  const updateFlag = async (newValue: any) => {
    await stuut.toggleFeatureFlag(flag, newValue);
    featureFlagStore.setFlag(flag, newValue);
  };

  void featureFlagStore.loadFeatureFlags();

  return { ready, updateFlag, value };
};
